/**
 * Component: sa-video
 * Description: Video section with YouTube/Vimeo support
 */
if (!customElements.get('sa-video')) {
  class SaVideo extends HTMLElement {
    constructor() {
      super();
      this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
    }

    connectedCallback() {
      const playButtons = this.querySelectorAll('.sa-video__play-button');
      if (playButtons.length > 0) {
        playButtons.forEach((button) => {
          button.addEventListener('click', this.handlePlayButtonClick);
        });
      }
      
      // Add click handler for cover image when video file is uploaded
      const coverImage = this.querySelector('.sa-video__cover-image--with-video');
      if (coverImage) {
        coverImage.addEventListener('click', this.handlePlayButtonClick);
      }
    }

    disconnectedCallback() {
      const playButtons = this.querySelectorAll('.sa-video__play-button');
      if (playButtons.length > 0) {
        playButtons.forEach((button) => {
          button.removeEventListener('click', this.handlePlayButtonClick);
        });
      }
    }

    handlePlayButtonClick(e) {
      e.preventDefault();
      const element = e.currentTarget;
      const containerId = element.getAttribute('data-container-id');
      const videoId = element.getAttribute('data-video-id');
      const videoContainerId = element.getAttribute('data-video-container');
      const wrapper = element.closest('.sa-video__wrapper');
      
      // Handle uploaded video file
      // Check if there's an uploaded video container
      const uploadedVideoContainer = this.querySelector('.sa-video__container--uploaded');
      if (uploadedVideoContainer) {
        const video = uploadedVideoContainer.querySelector('video');
        
        if (video && wrapper) {
          wrapper.classList.add('sa-video__wrapper--playing');
          video.style.display = 'block';
          video.play().catch(err => {
            console.error('Error playing video:', err);
          });
          return;
        }
      }
      
      // Also check videoContainerId attribute
      if (videoContainerId) {
        const videoContainer = this.querySelector(`#${videoContainerId}`);
        const video = videoContainer ? videoContainer.querySelector('video') : null;
        
        if (video && wrapper) {
          wrapper.classList.add('sa-video__wrapper--playing');
          video.style.display = 'block';
          video.play().catch(err => {
            console.error('Error playing video:', err);
          });
          return;
        }
      }
      
      // Handle YouTube/Vimeo video
      const container = containerId ? this.querySelector(`#${containerId}`) : null;

      if (!container || !videoId || !wrapper) {
        return;
      }

      wrapper.classList.add('sa-video__wrapper--playing');
      
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      iframe.setAttribute('allow', 'autoplay');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      
      container.innerHTML = '';
      container.appendChild(iframe);
    }
  }

  customElements.define('sa-video', SaVideo);
}
